import { Controller } from "stimulus"

const ACCORDION_CLASS = '.nav-accordion';

export default class extends Controller {
  static targets = [ "content", 'listSandbox' ];

  toggle(e) {
    e.preventDefault();
    const element = this.contentTarget;
    const expanded = element.classList.toggle('is-active');
    const control = e.currentTarget;
    const panelId = control.getAttribute('aria-controls');

    control.setAttribute('aria-expanded', expanded.toString());

    if (panelId) {
      const panel = document.getElementById(panelId);
      if (panel) panel.setAttribute('aria-hidden', (!expanded).toString());
    }
  }

  findElement(e) {
    return e.target.closest(ACCORDION_CLASS);
  }

  sandbox(e){
    document.querySelector('.list-sandbox').classList.remove('is-hidden')
  }

  live(e){
    document.querySelector('.list-sandbox').classList.add("is-hidden")
  }

}
